import type { IconNode } from '../types';

/**
 * @name peach
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMmEyIDIgMCAwIDAtMiAydjIiIC8+CiAgPHBhdGggZD0iTTEyIDYuNUE2IDYgMCAwIDEgMjIgMTFjMCA2LjEtNC41IDExLTEwIDExUzIgMTcuMSAyIDExYTYgNiAwIDAgMSAxMiAwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/peach
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const peach: IconNode = [
  ['path', { d: 'M14 2a2 2 0 0 0-2 2v2', key: '19zvbh' }],
  [
    'path',
    { d: 'M12 6.5A6 6 0 0 1 22 11c0 6.1-4.5 11-10 11S2 17.1 2 11a6 6 0 0 1 12 0', key: '2pm2r8' },
  ],
];

export default peach;
